import { ArrowLongDownIcon, XMarkIcon } from "@heroicons/react/20/solid"
import CustomButton from "../../common/button"
import { useState, type Dispatch, type SetStateAction } from "react"
import { type FilterType } from "./blogArticleSection"
import { ArrowLongUpIcon } from "@heroicons/react/24/outline"

import Image from "next/image"
import NdisImg from "public/images/NDIS/Registered-NDIS-Provider-square.png"
import GoogleReviewImg from "public/images/Google-5-star.png"

export type FilterTagWithType = { tag: string; type: "tag" }

type ArticleListProps = {
  filter: FilterType
  setFilter: Dispatch<SetStateAction<FilterType>>
  tags?: string[]
}

// available filter tags
const AvailableTags = (props: { tagType: string; open: boolean; tags?: string[]; setTag: (tag: string) => void }) => {
  return props.open ? (
    <div className="text-resp-sm relative flex flex-wrap justify-start gap-2 pb-4 max:container max:mx-auto">
      <div className="mb-2 h-[1px] w-full bg-white/30" />
      <div className="mr-2 flex items-center py-2 font-bold text-gray-300">
        <div className="my-auto">{props.tagType}</div>
      </div>
      {props.tags?.map((tag, i) => (
        <button
          key={i}
          onClick={() => props.setTag(tag)}
          className="group relative flex items-center rounded-full bg-white/10 px-3 py-1.5 font-bold text-gray-300 transition hover:bg-green/20 hover:text-green-light"
        >
          <div className="">{tag}</div>
        </button>
      ))}
    </div>
  ) : (
    <></>
  )
}

// selected filter tags
const ActiveTags = (props: { tagType: string; activeTags?: string[]; unsetTag: (i: number) => void }) => {
  return (
    <>
      {props.activeTags?.map((tag, i) => (
        <button
          key={`${props.tagType}-${i}`}
          onClick={() => props.unsetTag(i)}
          className="group relative flex items-center rounded-full bg-green/20 px-3 py-1.5 font-semibold text-green-light transition hover:bg-white/10"
        >
          {props.tagType}: {tag}
        </button>
      ))}
    </>
  )
}

const TagFilter = (props: ArticleListProps) => {
  const [openTags, setOpenTags] = useState(false)

  const hasFilters = !!props.filter?.tags?.length

  // console.log("props: ", props);
  // console.log("filter: ", props.filter);
  return (
    <>
      {/* tag align -- 2xl:mx-auto 2xl:max-w-screen-2xl or xl:max-w-7xl xl:mx-auto */}
      <div
        className={`flex flex-col md:flex-row ${openTags ? "items-start" : "items-start md:items-center"} justify-between gap-6 xl:mx-auto xl:max-w-7xl`}
      >
        <div className="flex w-full flex-col md:w-[75%]">
          {hasFilters && (
            <div className="text-resp-sm relative flex flex-wrap items-center justify-start gap-2 pb-4">
              <div className="text-resp-lg mr-2 flex items-center py-1.5 font-semibold text-gray-200">
                <div className="my-auto">{`Filtering for`}</div>
              </div>
              <ActiveTags
                tagType="Tag"
                activeTags={props.filter.tags}
                unsetTag={(i) =>
                  props.setFilter((filter) => ({
                    ...filter,
                    tags: filter.tags?.slice(0, i).concat(filter.tags.slice(i + 1)),
                  }))
                }
              />
              <button
                className="text-resp-lg flex items-center px-2 text-red-500 hover:text-red-600"
                onClick={() =>
                  props.setFilter((filter) => ({
                    ...filter,
                    tags: [],
                  }))
                }
              >
                <XMarkIcon className="mr-1 size-5 lg:size-6" />
                <div className="">Clear all</div>
              </button>
            </div>
          )}

          {/* filter button */}
          <div className="text-desk-resp-2xl group flex items-center text-white">
            {openTags ? (
              <CustomButton variant="textLink" onClick={() => setOpenTags(false)} className="px-0">
                Hide filters
                <ArrowLongUpIcon className="size-6 fill-white group-hover:fill-orange xl:size-7" />
              </CustomButton>
            ) : (
              <CustomButton variant="textLink" onClick={() => setOpenTags(true)} className="px-0">
                Show filters
                <ArrowLongDownIcon className="size-6 fill-white group-hover:fill-orange xl:size-7" />
              </CustomButton>
            )}
          </div>

          {/* Available Tag List */}
          <AvailableTags
            tagType="Tags"
            tags={props.tags?.filter((tag) => !props.filter.tags?.includes(tag))}
            setTag={(tag) =>
              props.setFilter((filter) => ({
                ...filter,
                tags: filter.tags?.concat([tag]) ?? [tag],
              }))
            }
            open={openTags}
          />
        </div>

        {/* logos */}
        <div
          className={`order-first flex flex-wrap items-center gap-6 md:order-last md:flex-nowrap md:justify-end lg:gap-8`}
        >
          <Image src={NdisImg} alt="NDIS-logo" height={60} className="lg:w-24" />
          {/* <Image
            src={GoogleReviewImg}
            alt="Google-5-star"
            height={50}
            className="lg:w-48"
          /> */}
        </div>
      </div>
    </>
  )
}

export default TagFilter
